import React, { useState, useEffect } from 'react';
import SensorTable from './SensorTable';
import HubTable from './HubTable';
import CustomEvent from './CustomEvent';
import { postEvent } from '../../../scripts/event';
import Modal from '../../UiComponents/Modal';
import InputField, { InputFieldContainer } from '../../UiComponents/InputField';
import Button from '../../UiComponents/Button';
import styled from 'styled-components';
import theme from '../../../UI/theme';
import { FaRedo } from 'react-icons/fa';
import { MT10Container } from '../../settings/venue/device/DeviceStyles';
import { getLocalAppVersion } from '../../../scripts/app';
import LocalAppVersion from './LocalAppVersion';
import { ButtonRowContainer, ModalContainer, ModalHeader, ModalText } from '../../panel/ModalStyles';
import { deleteHub } from '../../../scripts/hub';

const TableContainer = styled.div`
    font-size: ${theme.fontSize.small};
    td {
        padding-right: 6px;
    }
`

const DeviceTableContainer = props => {
    const [searchString, setSearchString] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState();
    const [selectedIds, setSelectedIds] = useState([]);
    const [localAppVersion, setLocalAppVersion] = useState();
    const [manuallyEnteredCustomerId, setManuallyEnteredCustomerId] = useState('');
    const [modalAction, setModalAction] = useState(null);
    const [hubIdToDelete, setHubIdToDelete] = useState('');

    useEffect(() => {
        getData()
    }, []);


    const getData = async () => {
        try {
            const res = await getLocalAppVersion();
            setLocalAppVersion(res);
        } catch (err) {

        }
    }

    const idField = props.deviceType === 'HUB' ? 'hubId' : 'sensorId'

    function selectDeviceHandler(deviceId) {
        if (isSelected(deviceId)) {
            setSelectedIds(selectedIds.filter(id => id !== deviceId));
        } else {
            setSelectedIds([...selectedIds, deviceId]);
        }
    }

    function selectAll(selectedState) {
        if (selectedState) {
            setSelectedIds(props.devices.map(device => device[idField]));
        } else {
            setSelectedIds([]);
        }
    }

    function isSelected(deviceId) {
        return selectedIds.includes(deviceId);
    }

    function performAction(action) {
        const selectedDevices = getSelectedDevices();

        if (selectedDevices.length === 0) {
            setModalAction(null);
            setModalContent(<>
                <ModalText>Please select at least one device to perform the action.</ModalText>
                <ButtonRowContainer>
                    <Button onClick={() => setShowModal(false)} secondary>Close</Button>
                </ButtonRowContainer>
            </>)
            setModalAction(null);
            setShowModal(true);
            return;
        }

        if (action === 'DELETE_HUB') {
            setManuallyEnteredCustomerId('');
            setHubIdToDelete('');
            setModalAction('DELETE_HUB');
            setShowModal(true);
            return;
        }

        setModalAction(null);
        setModalContent(<>
            <ModalText>This is the action: {action}</ModalText>
            <ModalText>Number of devices to update: {selectedDevices.length}</ModalText>
            <ModalText>Are you sure that you want to perform the action?</ModalText>
            <ButtonRowContainer>
                <Button onClick={() => handleEvent(action)} primary>Confirm</Button>
                <Button onClick={() => setShowModal(false)} secondary>Cancel</Button>
            </ButtonRowContainer>
        </>
        )
        setShowModal(true);
    }

    function handleManuallyEnteredCustomerIdChange(e) {
        let value = e.target.value;
        setManuallyEnteredCustomerId(value);

        let selectedDevices = getSelectedDevices();
        let selectedHub = selectedDevices[0];
        if (value === selectedHub.customerId.toString()) {
            setHubIdToDelete(selectedHub.hubId);
        } else {
            setHubIdToDelete('');
        }
    }

    function renderDeleteHubModal() {
        const selectedDevices = getSelectedDevices();

        if (selectedDevices.length > 1) {
            return <>
                <ModalText style={{ color: theme.colors.raspberryRed }}>
                    ERROR: You can only delete one hub at a time.
                </ModalText>
                <ButtonRowContainer>
                    <Button onClick={() => { setShowModal(false); setModalAction(null); }} secondary>Cancel</Button>
                </ButtonRowContainer>
            </>;
        }

        const customerId = selectedDevices[0]?.customerId?.toString() ?? '';

        return <>
            <ModalHeader style={{ color: theme.colors.raspberryRed }}>!!!  WARNING  !!!</ModalHeader>
            <ModalText style={{ color: theme.colors.raspberryRed }}>
            You are about to delete a hub at customerId: {customerId}
            </ModalText>
            <ModalText style={{ color: theme.colors.raspberryRed }}>
            This action is completely irreversible!
            </ModalText>

            <ModalText style={{ marginTop: '10px' }}>
            To confirm, please enter the customer ID below:
            </ModalText>

            <InputField
                value={manuallyEnteredCustomerId}
                onChange={(e) =>  handleManuallyEnteredCustomerIdChange(e)}
                onBlur={(e) => handleManuallyEnteredCustomerIdChange(e)   }
                type='number'
                placeholder="customer ID"
            />

            <ButtonRowContainer>
            <Button
                danger
                onClick={() => handleDeleteHub()}
                disabled={manuallyEnteredCustomerId !== customerId}
            >
                Confirm delete
            </Button>
            <Button onClick={() => { setShowModal(false); setModalAction(null); }} secondary>
                Cancel
            </Button>
            </ButtonRowContainer>
        </>;
    }

    function performCustomAction() {
        const selectedDevices = getSelectedDevices();
        setModalAction(null);
        setModalContent(<CustomEvent
            nDevices={selectedDevices.length}
            handleEvent={handleEvent}
            cancel={() => setShowModal(false)}
        />)
        setShowModal(true);
    }

    function getSelectedDevices() {
        return props.devices.filter(device => selectedIds.includes(device[idField]));
    }

    function handleEvent(action, payload) {
        const selectedDevices = getSelectedDevices();
        var command = action;
        selectedDevices.forEach(device => {
            postEvent(device[idField], null, command, payload);
        });
        closeModal();
    }

    async function handleDeleteHub() {
        let selectedDevices = getSelectedDevices();
        let selectedHub = selectedDevices[0];
        let hubId = hubIdToDelete;
        let manualCustomerId = Number(manuallyEnteredCustomerId);
        let customerId = selectedHub.customerId


        if (hubId && manualCustomerId === customerId) await deleteHub(hubId, customerId, manualCustomerId);
        closeModal();
    }


    const filterDevices = (search) => {
        var searchFields = ['customerId'];
        return props.devices.filter(device => {
            var contains = false;
            searchFields.forEach(field => {
                if (device[field] && device[field].toString().indexOf(search) > -1) {
                    contains = true;
                }
            });
            return contains;
        });
    }

    async function refresh() {
        await props.refreshDevices();
    }

    const filteredDevices = filterDevices(searchString);

    const closeModal = () => {
        setShowModal(false);
        setModalAction(null);
        setManuallyEnteredCustomerId('');
    };

    return <>
        <div >
            <InputFieldContainer>
                <label>Search by customer id</label><br />
                <InputField small value={searchString} onChange={e => setSearchString(e.target.value)} />
            </InputFieldContainer>
        </div>
        {localAppVersion ? <>
            <LocalAppVersion localAppVersion={localAppVersion} />
        </> : <></>}

        <ButtonRowContainer>
            <Button onClick={() => performCustomAction()} secondary small>Custom event</Button>
            <Button onClick={() => performAction('REBOOT')} secondary small>Reboot</Button>
            {props.deviceType === 'HUB' ? <>
                <Button onClick={() => performAction('PULL_GIT')} secondary small>Pull Git</Button>
                <Button onClick={() => performAction('RESTART_APP')} secondary small>Restart app</Button>
                <Button onClick={() => performAction('UPDATE_LOCAL_APP')} secondary small>Update local app</Button>
                <Button onClick={() => performAction('NPM_INSTALL')} secondary small>Npm install</Button>
                <Button onClick={() => performAction('REBOOT_HAT')} secondary small>Reboot Hat</Button>
                <Button onClick={() => performAction('START_IMAGE_WRITER_HUB')} secondary small>Write LG image</Button>
                <Button onClick={() => performAction('START_IMAGE_WRITER_SENSOR')} secondary small>Write Sensor image</Button>
                <Button onClick={() => performAction('DELETE_HUB')} danger small>Delete Hub</Button>
            </> : <></>}
        </ButtonRowContainer>

        <MT10Container>
            <Button tertiary small icon onClick={refresh}>
                <span><FaRedo /></span>
                <label>Refresh table</label>
            </Button>
        </MT10Container>

        <TableContainer>
            {props.deviceType === 'HUB' ? <>
                <HubTable devices={filteredDevices} isSelected={isSelected} selectAll={selectAll} selectHandler={selectDeviceHandler} />
            </> : <>
                <SensorTable sensors={filteredDevices} isSelected={isSelected} selectAll={selectAll} selectHandler={selectDeviceHandler} />
            </>}
        </TableContainer>


        <Modal show={showModal} close={() => closeModal()}>
            <ModalContainer>
                {modalAction === 'DELETE_HUB' ? renderDeleteHubModal() : modalContent}
            </ModalContainer>
        </Modal>
    </>


}

export default DeviceTableContainer;